module.exports = __webpack_public_path__ + "img/pic4_bg.f4c233b.webp";